import { Button } from "components/Graphs/Button";
import { DrawerClose } from "components/Graphs/Drawer";
import React from "react";

interface ConfigurationApplyButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const ConfigurationApplyButton: React.FC<
  ConfigurationApplyButtonProps
> = ({ children, disabled, onClick }) => (
  <DrawerClose asChild>
    <Button
      type="button"
      variant="primary"
      className="h-8 min-w-36 disabled:text-zinc-300 disabled:opacity-100 dark:disabled:text-zinc-300"
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Button>
  </DrawerClose>
);
